/**
 * 云服务类别 产品实例列表/实例图表页 监控项详情Drawer内容
 *
 * @format
 */

import React, { useEffect } from 'react'
import { _$ } from '@king-design/react'
import useFormTable from 'src/hooks/useFormTable'
import TablePage from 'src/components/TablePage'
import { DrawerProps } from 'src/pages/MonitorCloud/constants'
import API from 'src/api/ApiCloud'

const DrawerMonitorDetails: React.FC<DrawerProps> = ({ productType, instanceId, visible }) => {
  const scheme = {
    metricName: {
      title: _$('监控项'),
      width: 280
    },
    delay: `${_$('间隔')}(esc)`,
    application: {
      title: _$('监控类型')
    }
  }

  // useFormTable
  const { run, result, loading } = useFormTable(
    API.getInstanceMetrics,
    {
      params: { ProductType: productType, InstanceId: instanceId, PageSize: 999 },
      manual: true
    },
    data => {
      return {
        tableData: data?.metricList,
        totalCount: data?.totalCount
      }
    }
  )

  useEffect(() => {
    if (visible && instanceId && productType !== undefined) {
      run({
        ProductType: productType,
        InstanceId: instanceId
      })
    }
  }, [visible])

  return (
    <>
      <TablePage
        tableProps={{ data: loading ? [] : result, scheme, checkType: 'none' }}
        run={run}
        showPage={false}
      />
    </>
  )
}

export default DrawerMonitorDetails
